import React, { useState } from 'react';
import PropTypes from 'prop-types';

import { useDispatch } from 'react-redux';

import UploadDatasetModalComponent from './Component';
import UploadTrigger from './Trigger';
import { resetTypeOfUploadDataset } from 'store/scenes/dataSet';

const UploadDatasetModal = ({ onFileChange, isErrorType }) => {
  const dispatch = useDispatch();

  const [isOpen, setIsOpen] = useState(isErrorType);
  const openModal = () => setIsOpen(true);
  const closeModal = () => {
    setIsOpen(false);
    dispatch(resetTypeOfUploadDataset());
  };
  return (
    <>
      <UploadDatasetModalComponent
        isOpen={isOpen}
        onCloseModal={closeModal}
        onFileChange={onFileChange}
        isErrorType={isErrorType}
      />
      <UploadTrigger onOpenModal={openModal} />
    </>
  );
};

UploadDatasetModal.propTypes = {
  isErrorType: PropTypes.bool.isRequired,
  onFileChange: PropTypes.func.isRequired
};

export default UploadDatasetModal;
